import type { IconName } from '@customerio/pluma-icons';

/** The identity facet of a messaging channel. */
export type ChannelDefinition = {
  /** The channel's id, as the API spells it (`email`, `twilio`, `in_app`). */
  readonly id: string;
  /** The icon that stands for the channel wherever it is listed. */
  readonly icon: IconName;
};

/** Declares one channel. Pass the definition `as const satisfies ChannelDefinition` so its literals survive. */
export function defineChannel<Definition extends ChannelDefinition>(definition: Definition): Definition {
  return definition;
}
